module.exports = __webpack_public_path__ + "static/img/font-img.7cb5e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-img.png
// module id = DB7D
// module chunks = 83